<template>
  <div class="container contact" style="background:#fff;height:820px">
    <div class="p-3">
        <h2
      class="p-4"
      style="text-align:center;padding:10px 0;padding-bottom:.25rem!important;font-size:34px;font-weight:600"
    >{{$t("common.contact")}}</h2>
    <div class="Titleline"></div>
    </div>

    <!-- <img src="../../static/images/logo2.png" alt="" class="ContactLogo"> -->
    <!-- <img src="../../static/Updatedimg/contact us.jpg" alt="" class="ContactLogo2"> -->
    <b-row class="p-4 mapBox"> 
      <b-col class="Gaode-map col-md-6">
        <div class="amap-page-container">
          <div :style="{width:'100%',height:'400px'}">
            <!-- <el-amap-search-box class="search-box"
              :search-option="searchOption"
              
              :on-search-result="onSearchResult">
            </el-amap-search-box> -->
  
            <el-amap vid="amap" :zoom="zoom" :center="center"  class="amap-demo" >
              <el-amap-marker v-for="(marker,posindex) in markers" :position="marker.position" :key="posindex"></el-amap-marker>
              <el-amap-info-window v-if="window" :position="window.position" :visible="window.visible" :content="window.content" :offset="window.offset"></el-amap-info-window>

              <!-- <el-amap-info-window v-for="window in windows" :position="window.position" :content="window.content" :open="window.open"></el-amap-info-window> -->
            </el-amap>
          </div>

          <!-- <div class="toolbar">
          <span v-if="loaded">location: lng = {{ lng }} lat = {{ lat }}</span>
          <span v-else>正在定位</span>
        </div>
          <div v-on:click="req_post()">查询周边</div>-->
        </div>
      </b-col >
      <b-col class="col-md-6 infos">
        <div class="Detail_con">
          <b-row > 
            <b-col>
              <p>
                <span class="iconfont icon-dizhi"></span>
              {{$t("Contact.address")}}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                  <span class="iconfont icon-dianhua"></span>
              {{$t("Contact.phone")}}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                  <span class="iconfont icon-liuyan"></span>
              {{$t("Contact.email")}}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                  <span class="iconfont icon-fax"></span>
              {{$t("Contact.fax")}}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                  <span class="iconfont icon-wangzhan"></span>
              {{$t("Contact.website")}}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <p>
                <span class="iconfont icon-liuyan"></span>
              微信公众号：
              <b-img :src="qrimg" style="width:50%"></b-img>
              </p>
              
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import {pointMarker} from '../assets/styleJson.js'
export default {
  

  data() {
    const self = this;
    return {
      qrimg:require('../../static/Updatedimg/QRcode.jpg'),
      center: [120.20987,28.802473],
     
       
        markers: [],
        windows:[],
        
        window:{
           position: [120.20987,28.802473],
            content:"<h5 class='p-2'>"+'缙云县先锋工具有限公司'+"</h5>"+"<div>浙江省丽水市缙云县丽缙工业园区聚贤路272号</div>",//内容
            offset:[5,-28],//窗体偏移
            visible: true//初始是否显示
            
        },
      zoom:14,
    }
  },
  methods: {
   
    point(){
        let markers = [];
        let windows=[]
        let that=this
        pointMarker.forEach((item,index)=>{
          // console.log(item)
          markers.push({
            position: [item.lng,item.lat],
            icon:item.url,
            events: {
              click() {
                that.windows.forEach(window => {
                  window.visible = false; //关闭窗体
                });
                that.window = that.windows[index];
                that.$nextTick(() => {
                  that.window.visible = true;//点击点坐标，出现信息窗体
                });
              }
            }
          })
          windows.push({
            position: [item.lng,item.lat],
            content:"<div>"+item.text+"</div>",//内容
            offset:[5,-15],//窗体偏移
            visible: false//初始是否显示
          })
          // console.log(this.markers)
        })
        //  加点
        this.markers = markers;
        //加弹窗
        this.windows=windows
        

        // console.log(this.markers)
      },
    },
    mounted(){
      this.point()
    }


  
};
</script>



<style scoped>
@import url("../assets/css/anim.css");

@media (min-width: 768px) {
  .Gaode-map{
    flex: 0 0 60%;
    max-width: 60%;
}
  .infos{
    flex: 0 0 30%;
    max-width: 30%;
  }
}

@media (max-width: 768px){
  .Gaode-map{
    flex-basis: auto
}
  .Detail_con .row p{
    font-size: 16px !important;
}
  .Detail_con .row{
    margin-bottom: 10px !important;
}
  .contact{
    height: auto !important;
  }
}

.row .iconfont{
    font-size: 30px!important;
}

    .search-box {
      position: absolute;
      top: 25px;
      left: 70px;
    }
    .amap-page-container {
      position: relative;
    }
    .toolbar button {
      background: #42b983;
      border: 0;
      color: white;
      padding: 8px;
      margin: 0 5px;
      border-radius: 3px;
      cursor: pointer;
      margin-top:10px;
    }




.amap-demo {
  height: 400px;
}
/* .container h2 {
  visibility: hidden;
  animation: top-bottom 1s linear forwards;
} */
.ContactLogo {
  visibility: hidden;
  animation: bottom-top 1s linear forwards;
  padding-right: 30px;
  width: 50%;
}
.ContactLogo2 {
  width: 100%;
}
.Detail_con {
  /* padding-left: 30%; */
  padding-top: 20px;
  flex: 0 0 30%
}
.Detail_con .row{
    margin-bottom: 15px
}
.Detail_con .row p{
    font-size: 16px;
}
.Detail_con .col{
    padding: 0 5px
}

@media (max-width: 768px) {
    .search-box{
      width: 220px !important;
      left: 0;
    }
}
</style>
